import { DependencyList } from 'react';
import { HotkeyCallback, Keys, Options, useHotkeys as useReactHotkeys } from 'react-hotkeys-hook';

import { shouldIgnorePlatformShortcut } from '@/utilities/keyboardShortcuts';

type OptionsOrDependencyArray = Options | DependencyList;

const isDependencyList = (value: OptionsOrDependencyArray | undefined): value is DependencyList => {
    return Array.isArray(value);
};

export const usePlatformHotkeys = <T extends HTMLElement>(
    keys: Keys,
    callback: HotkeyCallback,
    optionsOrDependencies?: OptionsOrDependencyArray,
    dependencies?: OptionsOrDependencyArray,
) => {
    const options: Options = isDependencyList(optionsOrDependencies) ? {} : (optionsOrDependencies ?? {});
    const resolvedDependencies = isDependencyList(optionsOrDependencies) ? optionsOrDependencies : dependencies;
    const ignoreEventWhen = options.ignoreEventWhen;

    return useReactHotkeys<T>(
        keys,
        callback,
        {
            ...options,
            ignoreEventWhen: (event) => {
                return shouldIgnorePlatformShortcut(event) || !!ignoreEventWhen?.(event);
            },
        },
        resolvedDependencies,
    );
};
